import { z } from 'zod';
import BaseContainer from '../../../block-container';
export const ContainerPropsSchema = z.object({
    style: BaseContainer.schema.shape.style,
    props: z
        .object({
        childrenIds: z.array(z.string()).optional().nullable(),
    })
        .optional()
        .nullable(),
});
//# sourceMappingURL=ContainerPropsSchema.js.map